import { App } from './app.class';
import { Referrerdomains } from './referrerdomains.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';
import Upgrademodal from './upgrademodal.class';

export class Page {

    constructor() {

        // Vars
        this.current_step = 1;
        this.count_steps = 5;
        this.processors = [];

        // Elemente
        this.$btnBack = document.querySelector('button.go-back');
        this.$btnNext = document.querySelector('button.go-next');
        this.$btnSubmit = document.querySelector('button.submit');
        this.stepperEntries = document.querySelectorAll('nav.stepper li');
        this.stepperMobileEntries = document.querySelectorAll('nav.stepper-mobile li');
        this.$areaFormtemplate = document.querySelector('#area-formtemplate');
        this.radioFormContenttype = document.querySelectorAll('input[name="content-type"]');
        this.$form = document.querySelector('main form');
        this.$errorbox = this.$form.querySelector('.errorbox');
        this.$inputSiteUrl = this.$form.querySelector('input[name=site-url]');
        this.$langSelection = this.$form.querySelector('.lang-selection');
        this.radioNextPageType = document.querySelectorAll('input[name="next-page-type"]');
        this.$areaCustompage = document.querySelector('#area-custompage');
        this.$inputProcessors = this.$form.querySelector('input[name=processors]');
        this.$msgNoProcessor = this.$form.querySelector('.message.noprocessor');
        this.liProcessorsActive = this.$form.querySelectorAll('#list-processors > li');
        this.liProcessorsAdd = this.$form.querySelectorAll('#list-add-processors > li');

        // freigegebene Domains
        const referrerdomains = new Referrerdomains('#referrerdomains');

        // Validierung der Formulareingaben
        const form_validate = (successCallback) => {

            // Fehlermeldung ausblenden
            this.$errorbox.classList.add('hidden');

            // Validierungen
            const data = new FormData(this.$form);
            data.append("step", this.current_step);
            new Fetch().post(App.getUrl('form', 'create_validate'), data)
            .then(response => {
                successCallback();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorbox.querySelector('.cont').textContent = error.message;
                App.animateCSS(this.$errorbox, 'pullUp');
                this.$errorbox.classList.remove('hidden');
            })
            .finally(() => {

                // Buttons zurücksetzen
                this.$btnNext.classList.remove('loading');
                this.$btnNext.removeAttribute('disabled');
                this.$btnSubmit.classList.remove('loading');
                this.$btnSubmit.removeAttribute('disabled');
            });
        }

        // Klick auf Navibuttons
        this.$btnBack.addEventListener('click', event => {

            // Zurück
            if(this.current_step > 1) {
                --this.current_step;
                this.changeStepDisplay();
            }
        });
        this.$btnNext.addEventListener('click', event => {

            // Button deaktivieren
            this.$btnNext.classList.add('loading');
            this.$btnNext.setAttribute('disabled', true);

            // Validierung ausführen
            form_validate(()=>{

                // bei Step 2: Website-Adresse in Domainbeschränkungen übernehmen
                const url = this.$inputSiteUrl.value;
                let domain = "";
                try {
                    domain = new URL(url).hostname;
                } catch (error) {
                    domain = "";
                }
                if(domain != "") {
                    referrerdomains.addDomain(domain);
                }

                // Weiter
                ++this.current_step;
                this.changeStepDisplay();

                // Scroll to Top
                window.scrollTo(0, 80);
            });

        });
        this.$btnSubmit.addEventListener('click', event => {

            // Button deaktivieren
            this.$btnSubmit.classList.add('loading');
            this.$btnSubmit.setAttribute('disabled', true);

            // Validierung ausführen
            form_validate(()=>{

                // Formular anlegen
                const dataSubmit = new FormData(this.$form);
                new Fetch().post(App.getUrl('form', 'create_submit'), dataSubmit)
                .then(response => {

                    // Weiterleitung zur Integration
                    App.goto('form', 'overview', response.form_code);
                })
                .catch(error => {

                    // Fehlermeldung anzeigen
                    this.$errorbox.querySelector('.cont').textContent = error.message;
                    App.animateCSS(this.$errorbox, 'pullUp');
                    this.$errorbox.classList.remove('hidden');
                })
                .finally(() => {

                    // Buttons zurücksetzen
                    this.$btnSubmit.classList.remove('loading');
                    this.$btnSubmit.removeAttribute('disabled');
                });

            });
        });

        // zu Step springen
        if(this.stepperEntries.length > 0) {
            this.stepperEntries.forEach(($step, stepIndex) => {
                const $stepA = $step.querySelector('a');
                $stepA.addEventListener('click', event => {
                    event.preventDefault();

                    // Aufruf nur möglich wenn complete
                    if(!$step.classList.contains('complete'))
                        return;

                    // zu Schritt springen
                    this.current_step = stepIndex + 1;
                    this.changeStepDisplay();
                });
            });
        }
        if(this.stepperMobileEntries.length > 0) {
            this.stepperMobileEntries.forEach(($step, stepIndex) => {
                const $stepA = $step.querySelector('a');
                $stepA.addEventListener('click', event => {
                    event.preventDefault();

                    // Aufruf nur möglich wenn completed
                    if(!$step.classList.contains('completed'))
                        return;

                    // zu Schritt springen
                    this.current_step = stepIndex + 1;
                    this.changeStepDisplay();
                });
            });
        }

        // Schritt-Anzeige initialisieren
        this.changeStepDisplay();

        // Formular-Inhaltstyp-Auswahl
        this.radioFormContenttype.forEach(radio => {
            radio.addEventListener('change', event => {
                const val = document.querySelector('input[name="content-type"]:checked').value;
                if(val == "template") {
                    this.$areaFormtemplate.classList.add("open");
                }
                else {
                    this.$areaFormtemplate.classList.remove("open");
                }
            });
        });

        // Sprach-Auswahl
        if(this.$langSelection) {
            const langInputs = this.$langSelection.querySelectorAll("input");
            langInputs.forEach($langInput => {
                $langInput.addEventListener('change', event => {
                    const $langLabel = $langInput.closest("label");
                    this.$langSelection.querySelectorAll("label").forEach($l => { $l.classList.remove('checked') });
                    $langLabel.classList.add('checked');
                });
                if($langInput.checked) {
                    $langInput.closest("label").classList.add('checked');
                }
            });
        }

        // Prozessorauswahl
        this.processors = this.$inputProcessors.value.split(",");
        this.updateProcessorSelection();

        // Processor hinzufügen
        if(this.liProcessorsAdd) {
            this.liProcessorsAdd.forEach($li => {

                const $btnAdd = $li.querySelector('a.add');
                if($btnAdd) {
                    $btnAdd.addEventListener('click', event => {
                        event.preventDefault();

                        const processor_code = $li.dataset.processor;

                        // Pro-Feature
                        const isPro = event.target.classList.contains("pro") ? true : false;
                        const proStatus = this.$form.dataset.isPro === "true" ? true : false;

                        // Upgrade erforderlich
                        if(isPro && !proStatus) {

                            // Upgrade
                            const successMsg = event.target.dataset.upgradeSuccessmsg ?? '';
                            let upgradeType = "";
                            if(processor_code == "Autoresponse")     upgradeType = 'autoresponse';
                            else if(processor_code == "Whatsapp")    upgradeType = 'whatsapp';
                            Upgrademodal.open(
                                () => {

                                    // Pro-Status vermerkten
                                    this.$form.dataset.isPro = "true";

                                    // Erfolgsmeldung
                                    new Notification().success("Upgrade", successMsg);

                                    // Prozessor hinzufügen
                                    this.addProcessor(processor_code);
                                },
                                upgradeType
                            );
                        }

                        // Hinzufügen
                        else {
                            this.addProcessor(processor_code);
                        }
                    });
                }
            });
        }

        // Processor entfernen
        if(this.liProcessorsActive) {
            this.liProcessorsActive.forEach($li => {

                const $btnRemove = $li.querySelector('a.remove');
                if($btnRemove) {
                    $btnRemove.addEventListener('click', event => {

                        const processor_code = $li.dataset.processor;
                        const index = this.processors.indexOf(processor_code);
                        if (index !== -1) {
                            this.processors.splice(index, 1);
                        }
                        this.updateProcessorSelection();
                    });
                }
            });
        }

        // Erfolgsseiten-Typ-Auswahl
        this.radioNextPageType.forEach(radio => {
            radio.addEventListener('change', event => {
                const val = document.querySelector('input[name="next-page-type"]:checked').value;
                if(val == "custom") {
                    this.$areaCustompage.classList.add("open");
                }
                else {
                    this.$areaCustompage.classList.remove("open");
                }
            });
        });
    }

    addProcessor(processor_code) {
        if(!this.processors.includes(processor_code)) {

            // Hinzufügen
            this.processors.push(processor_code);

            // Anzeige aktualisieren
            this.updateProcessorSelection();

            // zu neuem Prozessor scrollen
            if(this.liProcessorsActive) {
                this.liProcessorsActive.forEach($l => {
                    const p = $l.dataset.processor;
                    if(p == processor_code) {
                        setTimeout(() => {
                            $l.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }, 100);
                    }
                });
            }
        }
    }

    updateProcessorSelection() {

        // Auswahl in Input übernehmen
        this.$inputProcessors.value = this.processors.join(',');

        // Aktive Prozessoren
        if(this.liProcessorsActive) {
            this.liProcessorsActive.forEach($li => {
                const processor_code = $li.dataset.processor;
                if(this.processors.includes(processor_code)) {
                    $li.classList.remove('hidden');
                }
                else {
                    $li.classList.add('hidden');
                }
            });
        }

        // Auswahl zum Hinzufügen
        if(this.liProcessorsAdd) {
            this.liProcessorsAdd.forEach($li => {
                const processor_code = $li.dataset.processor;
                if(this.processors.includes(processor_code)) {
                    $li.classList.add('hidden');
                }
                else {
                    $li.classList.remove('hidden');
                }
            });
        }

        // Meldung: kein Prozessor gewählt
        if(this.processors.length == 0) {
            this.$msgNoProcessor.classList.remove('hidden');
        }
        else {
            this.$msgNoProcessor.classList.add('hidden');
        }
    }

    changeStepDisplay() {

        // Fehlermeldung ausblenden
        this.$errorbox.classList.add('hidden');

        // Stepper aktualisieren
        if(this.stepperEntries.length > 0) {
            this.stepperEntries.forEach(($entry, index) => {

                let cl = "complete";
                if(index+1 == this.current_step) {
                    cl = "current";
                }
                else if(index+1 > this.current_step) {
                    cl = "upcoming";
                }

                $entry.classList.remove("complete", "current", "upcoming");
                $entry.classList.add(cl);
            });
        }

        // Stepper-Mobile aktualisieren
        if(this.stepperMobileEntries.length > 0) {
            this.stepperMobileEntries.forEach(($entry, index) => {

                let cl = "completed";
                if(index+1 == this.current_step) {
                    cl = "current";
                }
                else if(index+1 > this.current_step) {
                    cl = "upcoming";
                }

                $entry.classList.remove("completed", "current", "upcoming");
                $entry.classList.add(cl);
            });
        }

        // Beschriftung Stepper-Mobile aktualisieren
        const $step = document.querySelector('nav.stepper-mobile .currentStep');
        const $steps = document.querySelector('nav.stepper-mobile .countSteps');
        if($step) {
            $step.textContent = this.current_step;
        }
        if($steps) {
            $steps.textContent = this.count_steps;
        }

        // Submit-Button ein- ausblenden
        if(this.current_step === this.count_steps) {
            this.$btnSubmit.style.display = "inline-flex";
        }
        else {
            this.$btnSubmit.style.display = "none";
        }

        // Weiter-Button ein- und ausblenden
        if(this.current_step === this.count_steps) {
            this.$btnNext.style.display = "none";
        }
        else {
            this.$btnNext.style.display = "inline-flex";
        }

        // Zurück-Button de- aktivieren
        if(this.current_step == 1) {
            this.$btnBack.setAttribute('disabled', true);
        }
        else {
            this.$btnBack.removeAttribute('disabled');
        }

        // Bereich einblenden
        for(let n=1; n<=this.count_steps; ++n) {
            const $step = document.querySelector('#step'+n);
            if(n == this.current_step) {
                $step.classList.add('current');
            }
            else {
                $step.classList.remove('current');
            }
        }
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('form-create')) {
        new Page();
    }
});